import React, { createContext, useContext, useEffect, useState } from 'react';
import { userService } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            setUser({ token });
            userService.getProfile()
                .then(profileData => {
                    setProfile(profileData);
                })
                .catch(err => {
                    const status = err.response?.data?.status;
                    if (status) {
                        setProfile({ status });
                    } else {
                        setProfile({ status: 'ERROR' });
                        localStorage.removeItem('auth_token');
                        setUser(null);
                    }
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';
        const res = await fetch(`${API_URL}/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        });

        if (!res.ok) {
            const data = await res.json();
            throw new Error(data.error || 'Login failed');
        }

        const data = await res.json();
        localStorage.setItem('auth_token', data.token);
        setUser({ token: data.token, ...data.user });

        const profileData = await userService.getProfile();
        setProfile(profileData);
    };

    const logout = () => {
        localStorage.removeItem('auth_token');
        setUser(null);
        setProfile(null);
    };

    const value = {
        user,
        profile,
        setProfile,
        login,
        logout,
        loading,
        error
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
